/**
 * Auth middleware - redirects unauthenticated users to login page.
 * Apply to pages that require authentication via definePageMeta({ middleware: 'auth' }).
 */
import { useLocalePath } from '#imports'

export default defineNuxtRouteMiddleware((to) => {
  const { isLoggedIn } = useAuth()
  const localePath = useLocalePath()

  if (isLoggedIn.value) return

  // On SSR, if the auth cookie is present, defer the decision to the
  // client. This avoids flashing /login when SSR can't fully validate the
  // session (e.g., returning from Stripe, transient backend hiccup) — the
  // client-side hydration will populate user state via credentials:'include'
  // and either render the page or redirect after a real auth failure.
  if (import.meta.server) {
    const tokenCookie = useCookie('_authentication')
    if (tokenCookie.value) return
  }

  return navigateTo({
    path: localePath('/login'),
    query: { redirect: to.fullPath },
  })
})
